import { render, staticRenderFns } from "./PinList.vue?vue&type=template&id=08a051e0&scoped=true"
import script from "./PinList.vue?vue&type=script&lang=ts"
export * from "./PinList.vue?vue&type=script&lang=ts"
import style0 from "./PinList.vue?vue&type=style&index=0&id=08a051e0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a051e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a051e0')) {
      api.createRecord('08a051e0', component.options)
    } else {
      api.reload('08a051e0', component.options)
    }
    module.hot.accept("./PinList.vue?vue&type=template&id=08a051e0&scoped=true", function () {
      api.rerender('08a051e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ota/PinList.vue"
export default component.exports